<template>
  <div
    v-if="showPageSize"
    class="d-flex justify-content-center align-items-center mt-2">
    <div
      v-if="pagesCount > 1"
      class="pagination_div mb-0">
      <paginate
        :value="page"
        :page-count="pagesCount"
        container-class="pagination-container"
        page-class="page-item"
        prev-class="btn btn-primary"
        next-class="btn btn-primary"
        active-class="active-class"
        :click-handler="onPageClick" />
    </div>
    <page-size-select
      class="ml-3"
      :value="pageSize"
      :options="pageSizeOptions"
      @change="$emit('page-size-change', $event)"
    />
  </div>
  <div
    v-else-if="pagesCount > 1"
    class="pagination_div">
    <paginate
      :value="page"
      :page-count="pagesCount"
      container-class="pagination-container"
      page-class="page-item"
      prev-class="btn btn-primary"
      next-class="btn btn-primary"
      active-class="active-class"
      :click-handler="onPageClick" />
  </div>
</template>

<script>
  import PageSizeSelect from '@base/components/PageSizeSelect.vue'
  import { PAGE_SIZE_OPTIONS, DEFAULT_PAGE_SIZE } from '@base/configs'

  export default {
    name: 'Pagination',

    components: {
      PageSizeSelect
    },

    props: {
      page: {
        type: Number,
        required: true
      },
      pagesCount: {
        type: Number,
        required: true
      },
      pageSize: {
        type: Number,
        default: null
      },
      count: {
        type: Number,
        default: null
      },
      pageSizeOptions: {
        type: Array,
        default: () => PAGE_SIZE_OPTIONS
      }
    },

    computed: {
      hasPageSize () {
        return this.pageSize !== null
      },
      showPageSize () {
        return this.hasPageSize && (this.pagesCount > 1 || this.count > DEFAULT_PAGE_SIZE)
      }
    },

    methods: {
      onPageClick (pageNum) {
        this.$emit('page-change', pageNum)
      }
    }
  }
</script>
